require('/opt/odin/app/frontend/components/start_now/index.module.scss');module.exports = "../../app/cells/components/start_now/show.erb";